import React from "react";
import { connect } from "react-redux";

import withStyles from "@material-ui/styles/withStyles";
import SyncIcon from "mdi-material-ui/Sync";

import {
  List,
  TextField,
  Datagrid,
  Filter,
  ReferenceInput,
  SelectInput,
  FilterButton,
  Button,
  crudGetList,
  // Create,
  // Edit,
  // Show,
  // SimpleForm,
  // SimpleShowLayout,
  // ReferenceInput,
  // ReferenceField,
  // AutoCompleteInput,
  // TextInput,
  // required,
  // ShowButton,
  // EditButton
  //   DeleteButton
} from "jazasoft";
import { Role } from "../utils/types";

const inputOptions = {
  xs: 12,
  fullWidth: true,
  options: { fullWidth: true },
};

// const createStyle = theme => ({});

// export const CreatePermission = withStyles(createStyle)(
//   ({ classes, ...props }) => {
//     return (
//       <Create {...props}>
//         <SimpleForm className={classes.form} redirect="home">
//           <TextInput source="name" validate={[required()]} {...inputOptions} />
//           <TextInput source="permissionId" validate={[required()]} {...inputOptions} />
//           <TextInput
//             source="scopes"
//             validate={[required()]}
//             {...inputOptions}
//           />
//           <TextInput label="Operations" source="actions" {...inputOptions} />
//           <TextInput
//             label="Permission Id"
//             source="permissionId"
//             validate={[required()]}
//             {...inputOptions}
//           />
//           <TextInput source="desc" {...inputOptions} />
//           <ReferenceInput source="appId" reference="apps">
//             <AutoCompleteInput optionText="appName" />
//           </ReferenceInput>
//         </SimpleForm>
//       </Create>
//     );
//   }
// );

// const editStyle = theme => ({});

// export const EditPermission = withStyles(editStyle)(({ classes, ...props }) => {
//   return (
//     <Edit {...props}>
//       <SimpleForm className={classes.form} redirect="home">
//         <TextInput source="name" validate={[required()]} {...inputOptions} />
//         <TextInput source="scopes" validate={[required()]} {...inputOptions} />
//         <TextInput label="Operations" source="actions" {...inputOptions} />
//         <TextInput
//           label="Permission Id"
//           source="permissionId"
//           validate={[required()]}
//           {...inputOptions}
//         />
//         <TextInput source="desc" {...inputOptions} />
//         <ReferenceInput source="appId" reference="apps">
//           <AutoCompleteInput optionText="appName" />
//         </ReferenceInput>
//       </SimpleForm>
//     </Edit>
//   );
// });

// const fieldOptions = {
//   xs: 12,
//   sm: 4
// };

// const viewStyle = theme => ({});

// export const ViewPermission = withStyles(viewStyle)(({ classes, ...props }) => {
//   return (
//     <Show {...props}>
//       <SimpleShowLayout>
//         <TextField label="Permission ID" source="permissionId" {...fieldOptions} />
//         <TextField source="name" {...fieldOptions} />
//         <ReferenceField source="appId" reference="apps">
//           <TextField source="appName" {...fieldOptions} />
//         </ReferenceField>
//         <TextField source="scopes" {...fieldOptions} />
//         <TextField label="Operations" source="actions" {...fieldOptions} />
//         <TextField source="desc" {...fieldOptions} />
//       </SimpleShowLayout>
//     </Show>
//   );
// });

const filters = (roles = []) => (
  <Filter>
    <ReferenceInput
      label="App"
      resource="apps"
      source="appId"
      reference="apps"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}
    >
      <SelectInput />
    </ReferenceInput>
    {roles.includes(Role.MASTER) && (
      <ReferenceInput
        label="Tenant"
        resource="tenants"
        source="tenantId"
        reference="tenants"
        pageSize={100}
        sort={{ field: "name", order: "asc" }}
        {...inputOptions}
      >
        <SelectInput />
      </ReferenceInput>
    )}
  </Filter>
);

const homeStyle = (theme) => ({
  buttonEdit: {
    width: theme.spacing(14),
  },
  buttonDelete: {
    width: theme.spacing(16),
  },
});

export const PermissionHome = connect()(
  withStyles(homeStyle)(({ classes, dispatch, ...props }) => {
    const onSync = () => {
      dispatch(
        crudGetList(props.resource, null, null, null, null, {
          params: { sync: true },
        })
      );
    };
    const roles = props.roles || [];
    return (
      <List
        searchKeys={["name", "key"]}
        filters={roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) ? filters(roles) : null}
        actions={({ resource }) => (
          <div>
            <Button label="Sync" showLabel={false} onClick={onSync}>
              <SyncIcon />
            </Button>
            {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && <FilterButton showLabel={false} resource={resource} />}
          </div>
        )}
        parse={({ appId, tenantId }) => ({
          "app.id": appId,
          "tenant.id": tenantId,
        })}
        {...props}
      >
        <Datagrid>
          <TextField source="name" />
          <TextField label="Key" source="key" />
          {/* <TextField label="Parent Key" source="parentKey" /> */}
          {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && <TextField label="App" source="app.name" />}
          {roles.includes(Role.MASTER) && <TextField label="Tenant" source="tenant.name" />}
        </Datagrid>
      </List>
    );
  })
);
